import React, { useContext } from 'react';

import Config from '@skin_config';
import { useTranslation } from '@common/hooks/translation';
import { PopupContext } from '@app/dev/contexts/popup';
import { POPUPS } from '@common/constants/popups';

const ClientDepositButton = () => {
  const t = useTranslation();
  const [{ openPopup }] = useContext(PopupContext);

  if (!Config.main.enableClientDepositMode) return null;

  return (
    <button type="button" className="client-deposit-button" onClick={() => openPopup(POPUPS.CLIENT_DEPOSIT_POPUP)}>
      <i className="global-icon icon-client-deposit" />
      <div className="client-deposit-button-text">
        <span>{t('Client')}</span>
        <span>{t('Deposit')}</span>
      </div>
      <i className="global-icon icon-arrow-right" />

    </button>
  );
};

export default ClientDepositButton;
